import { api } from "../../api";
import {
  ShippingResponse,
  RequestShippingParams,
  ShippingRowType,
  ShippingCaseShiftingResponse,
} from "./types";

export async function getShippingCasesListApi(
  params: RequestShippingParams,
): Promise<ShippingResponse> {
  const { data } = await api.get<ShippingResponse>(`/api/shipping-cases`, {
    params,
  });
  return data;
}

export async function getShippingCasesShiftingApi(
  id: number,
  params: any,
): Promise<ShippingCaseShiftingResponse> {
  const { data } = await api.get<ShippingCaseShiftingResponse>(
    `/api/shipping-cases/${id}/warehouse-shiftings`,
    { params },
  );
  return data;
}

export async function exportShippingApi(
  params: Partial<ShippingRowType>,
): Promise<{ file: Blob; filename: string }> {
  const response = await api.get(`/api/shipping-cases/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}
